// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"cbd80209","558":"8c008889","3279":"c94de16b","5998":"e9f67873","6058":"b8ceb3bb","7242":"90f2abe3","8861":"b8ceb3bb","8908":"9ef3d479","8992":"4805fb3e","9576":"43240465"}[chunkId] + ".chunk.css";
};